
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import { ITicket } from '@/types/models';
import api, { IGetRequest } from '@/api/my/tickets';
import { PER_PAGE } from '@/const';
import utils from '@/utils';
import { TicketPriority, TicketStatus } from '@/types/enums';
import TicketAdd from './components/tickets/TicketAdd.vue';

interface IForm extends IGetRequest {
  currentPage: number;
}

interface IState {
  isTicket: boolean;
  count: number;
  tickets: ITicket[];
  isAdd: boolean;
  formInline: IForm;
}

export default defineComponent({
  components: { TicketAdd },
  name: 'Tickets',
  data() {
    return {
      isTicket: false,
      count: 0,
      tickets: [],
      isMessages: false,
      messagesCount: 0,
      messages: [],
      isAdd: false,
      formInline: {
        status: TicketStatus.All,
        ticketNo: '',
        keyword: '',
        currentPage: 1,
        offset: 0,
        limit: PER_PAGE,
      },
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        this.isTicket = res.isTicket;
        this.count = res.count;
        this.tickets = res.tickets;
      });
    },

    getAllTicketStatus() {
      return Object.values(TicketStatus);
    },

    getTicketStatusType(ticket: ITicket) {
      if (ticket.status === TicketStatus.Closed) {
        return 'success';
      }
      if (ticket.status === TicketStatus.Dealing) {
        return 'info';
      }
      return 'danger';
    },

    getTicketCategory(ticket: ITicket) {
      return utils.getTicketCategory(ticket.category);
    },

    getTicketStatus(status: TicketStatus) {
      return utils.getTicketStatus(status);
    },

    getTicketPriority(status: TicketPriority) {
      return utils.getTicketPriority(status);
    },

    btnSearchClick() {
      this.apiGet();
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      this.btnSearchClick();
    },

    btnAddClick() {
      if (this.isTicket) {
        this.isAdd = true;
      } else {
        Swal.fire({
          title: '提交工单',
          text: '系统检测到您尚未存在订单（网站云、模板、插件），暂无法提交工单！',
          icon: 'warning',
          confirmButtonText: '关 闭',
          showConfirmButton: true,
          showCancelButton: false,
          customClass: {
            confirmButton: 'el-button el-button--danger',
            cancelButton: 'el-button el-button--default',
          },
          buttonsStyling: false,
        });
      }
    },

    btnViewClick(ticket: ITicket) {
      ticket.isRead = true;
      utils.pageOpen(`/my/tickets/${ticket.ticketNo}`);
    },

    isUnread(ticket: ITicket) {
      return ticket.status === TicketStatus.Waiting && !ticket.isRead;
    },

    getClassName(ticket: ITicket) {
      if (ticket.status === TicketStatus.Waiting && !ticket.isRead) {
        return 'unread';
      }
      return '';
    },

    handleTicketAddClose(isFresh: boolean) {
      this.isAdd = false;
      if (isFresh) {
        this.formInline.status = TicketStatus.All;
        this.formInline.offset = 0;
        this.apiGet();
      }
    },
  },
  mounted() {
    this.apiGet();
  },
});
